import { render, staticRenderFns } from "./TopPerformedIbTable.vue?vue&type=template&id=a0346a96&scoped=true"
import script from "./TopPerformedIbTable.vue?vue&type=script&lang=js"
export * from "./TopPerformedIbTable.vue?vue&type=script&lang=js"
import style0 from "./TopPerformedIbTable.vue?vue&type=style&index=0&id=a0346a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0346a96",
  null
  
)

export default component.exports